/* eslint-disable */
import React from 'react'
import AppNavLink from './AppNavLink'
import {
  Profile,
  ClipboardChecklist,
  CreditCard,
  Document,
  Meter
} from '@entrata/portals-common/lib/icons'
import styled from '@emotion/styled'

const StyledAppNav = styled('nav')`
  width: 100%;
  height: 63px;
  background: white;
  border-top: 1px solid ${({ theme }) => theme.gray.medium};
  display: table;
  margin: 0;
  text-align: center;
  position: fixed;
  bottom: 0;
`

const AppNav = () => (
  <StyledAppNav>
    <AppNavLink to='/app/policies/' Icon={Document}>
      Policies
    </AppNavLink>
    <AppNavLink to='/app/payments/' Icon={CreditCard}>
      Payments
    </AppNavLink>
    {/* <AppNavLink to='/app/make-claim/' Icon={ClipboardChecklist}>
      Make a Claim
    </AppNavLink> */}
    <AppNavLink to='/app/credit/' Icon={Meter}>
      Credit
    </AppNavLink>
    <AppNavLink to='/app/account/' Icon={Profile}>
      Account
    </AppNavLink>
  </StyledAppNav>
)

export default AppNav
